import React, { useState } from "react";
import cx from "clsx";
import { Button } from "../../../../../../shared/Button/Button";
import styles from "./CellularCapability.module.scss";
import CellularCapabilityConfirmationModal from "./CellularCapabilityConfirmationModal/CellularCapabilityConfirmationModal";

const CellularCapability = ({ device, refetch }) => {
  const [showModal, setShowModal] = useState(false);
  const buttonLabel = device.cellula_active
    ? "Deactivate Cellular"
    : "Activate Cellular";

  return (
    <>
      <Button
        variant="text"
        className={cx(styles.ctoButton, styles.noHoverBg)}
        onClick={() => setShowModal(true)}
      >
        {buttonLabel}
      </Button>
      {showModal && (
        <CellularCapabilityConfirmationModal
          onClose={() => setShowModal(false)}
          isCurrentlyActive={device.cellular_active}
          deviceId={device.id}
          refetch={refetch}
        />
      )}
    </>
  );
};

export default CellularCapability;
